/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAPIAction } from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('org', [
  'basic',
  'updateBasic',
]);

function basic() {
  return createAPIAction(
    types.basic,
    {
      endpoint: '/org/basic',
      method: 'GET',
    })();
}

function updateBasic(data) {
  return createAPIAction(
    types.updateBasic,
    {
      endpoint: '/org/basic',
      method: 'PUT',
      body: data,
    },
  )();
}


export default {
  basic,
  updateBasic,
};




// WEBPACK FOOTER //
// ./src/redux/actions/org.js